import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetJobMaterialTotalOverview = async (entityID) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/JobMaterial/getTotalOverview?entityID=${entityID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      
      if (response.ok && !data.isError) {               
        return data;        
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};

export const GetJobAssetTotalOverview = async (entityID) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/JobAsset/getTotalOverview?entityID=${entityID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      
      if (response.ok && !data.isError) {               
        return data;        
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};

export const GetJobLaborTotalOverview = async (entityID) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/JobLabor/getTotalOverview?entityID=${entityID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      
      if (response.ok && !data.isError) {               
        return data;        
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};

export const GetJobMiscCostTotalOverview = async (entityID) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/JobMiscCost/getTotalOverview?entityID=${entityID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      
      if (response.ok && !data.isError) {               
        return data;        
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};

export const GetJobSubcontractorTotalOverview = async (entityID) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/JobSubcontractor/getTotalOverview?entityID=${entityID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      
      if (response.ok && !data.isError) {               
        return data;        
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};